module.exports = __webpack_public_path__ + "static/media/iconEmptyCall.b8d5636f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/agent/Tabs/Payments/img/iconEmptyCall.svg
// module id = 6491
// module chunks = 16